import { useRecoilState } from 'recoil'
import deleteClaimApprovalModalAtom from '@/recoil/deleteClaimApprovalModal'
import message from '@/libs/message'
import { useDeleteHealthClaimApprover } from '@/services/healthClaim/useDeleteHealthClaimApprover'

export default function DeleteApprovalModalHook() {
  const [deleteClaimApprovalModal, setDeleteClaimApprovalModal] = useRecoilState(
    deleteClaimApprovalModalAtom,
  )

  const { mutateAsync: deleteApproval, isPending: isPendingApproval } =
    useDeleteHealthClaimApprover()

  const handleSetDeleteApprovalModal = () => {
    if (deleteClaimApprovalModal.backofficeUserId)
      deleteApproval(deleteClaimApprovalModal.backofficeUserId)
        .then(() => {
          if (deleteClaimApprovalModal.onSuccess) deleteClaimApprovalModal.onSuccess()
          setDeleteClaimApprovalModal({
            backofficeUserId: undefined,
            open: false,
            fullname: undefined,
          })
        })
        .catch(() => {
          message.error({
            content: `เกิดข้อผิดพลาด`,
            duration: 10,
          })
        })
  }

  const onCancelModal = () => {
    setDeleteClaimApprovalModal({ backofficeUserId: undefined, open: false, fullname: undefined })
  }

  return {
    deleteClaimApprovalModal,
    handleSetDeleteApprovalModal,
    onCancelModal,
    fullname: deleteClaimApprovalModal.fullname,
    isPendingApproval,
  }
}
